import React from "react";
import { ViewProvider } from "../account/ViewProvider.js";
import { useVatReport } from "./VatReportProvider.js";
import { StaticPeriodProvider } from "../PeriodProvider.js";
import { AccountTotal } from "../account/AccountTotal.js";
import { ItemsTable } from "../account/ItemsTable.js";
import { Lia_02 } from "../../../model/accounting/Chart.js";

/**
 * Renders the account items view for the VAT report page.
 */
export const VatReportAccount = () => {
  const report = useVatReport();

  if (!report) {
    return null;
  }

  return (
    <StaticPeriodProvider year={report.year} month={report.month} titleSearch="">
      <ViewProvider accountId={Lia_02}>
        <AccountTotal />
        <ItemsTable />
      </ViewProvider>
    </StaticPeriodProvider>
  );
};
